// Dashboard Helpers ───────────────────────────────────────────────────────────────────

export const formatTime = (iso: string) => {
    return new Date(iso).toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
    })
}

export const formatRelative = (iso: string) => {
    const date = new Date(iso)
    const now = new Date()
    const diffDays = Math.floor((date.getTime() - now.getTime()) / 86_400_000)
    if (diffDays === 0) return "Today"
    if (diffDays === 1) return "Tomorrow"
    if (diffDays < 7) return `In ${diffDays} days`
    return new Date(iso).toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" })
}

export const daysAgo = (iso: string) => {
    const diff = Math.floor((Date.now() - new Date(iso).getTime()) / 86_400_000)
    if (diff === 0) return "today"
    if (diff === 1) return "yesterday"
    return `${diff} days ago`
}
